import { merchantoauthSessionKeys } from '../constants/merchantoauth';
import { OAUTH_IFRAME } from './merchantoauth';
import isRemoteLoading from './remote-loading';

declare global {
  interface Window {
    connectedThoughtProvider?: boolean;
    connectionRedirectUrl?: string;
  }
}

export const insideProviderIframe = () => {
  const rawAncestors = window.location.ancestorOrigins || [];
  const ancestorOrigins = Array.from(rawAncestors);

  const { providers } = merchantoauthSessionKeys.connect;

  const inIFrame = ancestorOrigins.some(ancestor => {
    const providersNames = Object.keys(providers) as Array<
      keyof typeof providers
    >;

    return providersNames.some(key =>
      ancestor.includes(providers[key].domain as string)
    );
  });

  if (inIFrame) return true;
  if (isRemoteLoading()) return false;

  return window.self !== window.top;
};

export const closeIframeAfterStipeConnect = () => {
  if (
    window.location.pathname === '/signup/account-created' &&
    !!window.opener
  ) {
    window.parent.close();
  }
};

export const closeIframeAfterSigninConnect = () => {
  if (window.location.pathname.includes('/auth/callback') && !!window.opener) {
    window.connectedThoughtProvider = true;
    window.connectionRedirectUrl = window.location.href;

    if (window.self !== window.top) {
      window.close();
    }
  }
};

export const getHost = (provider: 'bigcommerce' | 'shopify' | 'wix') => {
  const rawAncestors = window.location.ancestorOrigins || [];
  const oauthIframeData = JSON.parse(
    localStorage.getItem(OAUTH_IFRAME) || 'null'
  );
  const { providers } = merchantoauthSessionKeys.connect;

  const host = oauthIframeData
    ? `${oauthIframeData.account}${providers[provider].domain}`
    : '';

  const ancestorOrigins = [...Array.from(rawAncestors), host];

  return (
    ancestorOrigins.find(i => i.includes(providers[provider].domain)) || ''
  );
};

export const getBigcommerceAccount = () => {
  const host = getHost('bigcommerce');

  const shop = host.split(
    merchantoauthSessionKeys.connect.providers.bigcommerce.domain
  )[0];

  if (shop) {
    return `stores/${shop.split('-')[1]}`;
  }
};

export const getShopifyAccount = () => {
  const host = getHost('shopify');
  return host && host.split('https://')[1];
};

export const getWixOauthId = () => {
  return new URL(window.location.href).searchParams.get('providerId');
};
